import axios from 'axios'
import Decimal from 'decimal.js'
import { ElMessage } from 'element-plus'

export const getUrls = (urls) => {
  const result = []
  const totalUrl = JSON.parse(urls)
  for (let i = 0; i < totalUrl.length; i++) {
    result.push(totalUrl[i].url)
  }
  return result
}

const normalizeFileUrl = (rawUrl) => {
  if (!rawUrl) {
    return ''
  }
  if (typeof rawUrl !== 'string') {
    return ''
  }
  const url = rawUrl.trim()
  if (!url) {
    return ''
  }
  if ((url.startsWith('[') && url.endsWith(']')) || (url.startsWith('{') && url.endsWith('}'))) {
    try {
      const parsed = JSON.parse(url)
      if (Array.isArray(parsed) && parsed.length > 0) {
        return parsed[0].url || ''
      }
      if (parsed && parsed.url) {
        return parsed.url
      }
    } catch (error) {
      return url
    }
  }
  return url
}

const getFileExtension = (url) => {
  const normalized = normalizeFileUrl(url)
  if (!normalized) {
    return ''
  }
  const fileName = normalized.split('/').pop().split('?')[0]
  if (!fileName || fileName.indexOf('.') === -1) {
    return ''
  }
  return fileName.split('.').pop().toLowerCase()
}

export const transToCheckFile = (url) => {
  const normalizedUrl = normalizeFileUrl(url)
  if (!normalizedUrl) {
    ElMessage.warning('暂无可预览附件')
    return
  }
  const extension = getFileExtension(normalizedUrl)
  if (extension === 'pdf') {
    window.open(normalizedUrl, '_blank')
    return
  }
  if (['xlsx', 'xls', 'doc', 'docx', 'ppt', 'pptx'].includes(extension)) {
    window.open('https://view.officeapps.live.com/op/view.aspx?src=' + encodeURIComponent(normalizedUrl), '_blank')
    return
  }
  window.open(normalizedUrl, '_blank')
}

export const downLoadContractFile = async (url) => {
  const normalizedUrl = normalizeFileUrl(url)
  if (!normalizedUrl) {
    ElMessage.warning('暂无可下载附件')
    return
  }
  const response = await axios.get(normalizedUrl, { responseType: 'blob' })
  const pdfUrl = window.URL.createObjectURL(new Blob([response.data]))
  const link = document.createElement('a')
  const lastPart = decodeURIComponent(normalizedUrl.split('/').pop().split('?')[0])
  link.href = pdfUrl
  link.setAttribute('download', lastPart)
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

export const subtractDecimal = (num1, num2) => {
  return new Decimal(num1).minus(new Decimal(num2)).toString()
}

export const addDecimal = (num1, num2) => {
  return Decimal.add(num1, num2).toNumber()
}

export const uuid = (len, radix = 62) => {
  const chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('')
  const uuid = []
  radix = radix || chars.length

  for (let i = 0; i < len; i++) {
    uuid[i] = chars[0 | Math.random() * radix]
  }

  return uuid.join('')
}

export function wrapperPercentage(k) {
  return k ? `${k}%` : '0%'
}
